export default __webpack_public_path__ + "static/media/DreamCastDark.f7261003.svg";